import React, { useContext } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './style.module.scss';
import CheckmarkIcon from 'components/icon/checkmark-icon';
import Button from 'components/control/button';
import { IModalContext, ModalContext } from 'contexts/modal';
import { LOCALE_COMMON_PATHS, Namespaces } from 'types/locales';

interface Props {
  isFromConnectAgent?: boolean;
}

export default function SignUpCta({ isFromConnectAgent }: Props) {
  const { t } = useTranslation(Namespaces.COMMON);
  const { openModal } = useContext(ModalContext) as IModalContext;

  const redirectToLogin = () => {
    openModal('login-registration');
  };

  return (
    <div className={styles['component']}>
      <p>
        {t(
          isFromConnectAgent 
            ? LOCALE_COMMON_PATHS.SIGN_UP_CTA_CREATE_ACCOUNT_HEADING
            : LOCALE_COMMON_PATHS.SIGN_UP_CTA_SAVE_LISTING_HEADING,
          {
            defaultValue: isFromConnectAgent
              ? 'Create a free account'
              : 'Sign up to save this listing',
          }
        )}
      </p>
      <p className={styles['benefit-item']}>
        <CheckmarkIcon />
        {t(LOCALE_COMMON_PATHS.SIGN_UP_CTA_SAVE_FAVOURITE_LISTINGS, {
          defaultValue: 'Save your favourite listings',
        })}
      </p>
      <p className={styles['benefit-item']}>
        <CheckmarkIcon />
        {t(LOCALE_COMMON_PATHS.SIGN_UP_CTA_GET_ALERTS, {
          defaultValue: 'Get alert for similar listings',
        })}
      </p>
      <p className={styles['benefit-item']}>
        <CheckmarkIcon />
        {t(LOCALE_COMMON_PATHS.SIGN_UP_CTA_VIEW_DETAILS, {
          defaultValue: 'View listing details',
        })}
      </p>
      <Button 
        label={t(LOCALE_COMMON_PATHS.SIGN_UP_CTA_LOGIN_SIGNUP_BUTTON, {
          defaultValue: 'Log In or Sign Up',
        })} 
        theme="primary" 
        onClick={redirectToLogin} 
      />
    </div>
  );
}
